import ForgotPassword from "../pages/ForgotPassword.jsx";
import Login from "../pages/Login.jsx";
import OTPVerification from "../pages/Otpverification.jsx";
import SetNewPassword from "../pages/SetNewPassword.jsx";
import StaffManagement from "../pages/Staff.jsx";
import AppointmentManagement from "../pages/AppointmentManagement.jsx";
import DashBoard from "../pages/DashBoard.jsx";
import PatientsManagement from "../pages/PatientsManagement.jsx";
import TaskManagement from "../pages/TaskManagement.jsx";
import BillingManagement from "../pages/BillingManagement.jsx";
import Settings from "../pages/Settings.jsx";
import StaffAttendanceManagement from "../pages/StaffAttendance.jsx";

export const ROLE = {
  ADMIN: "ADMIN",
  CLIENT: "CLIENT",
  STAFF: "STAFF",
};

export const WEB_ROUTES = {
  login: "/",
  dashboard: "/dashboard",
  staff: "/staff",
  patient: "/patient",
  task: "/task",
  appointment: "/appointment",
  billing: "/billing",
  settings: "/settings",
  staffattendance: "/staff-attendance",
};

export const validation = {
  emailMax: 322,
  passwordMin: 8,
  passwordMax: 32,
  nameMin: 5,
  nameMax: 60,
  descriptionMax: 255,
  text: 120,
  amount: 10,
  phoneNumberMax: 12,
};

export const validationText = {
  general: "Required",
  emailRequired: "Email is required",
  titleRequired: "Title is required",
  nameemailMax: `Max length is ${validation.emailMax}`,
  invalidEmail: "Invalid email pattern",
  amountMax: `Max length is ${validation.amount}`,
  currentPasswordRequired: "Current password is required",
  newPasswordRequired: "New Password is required",
  confirmNewPasswordRequired: "Confirm new password is required",
  passwordRequired: "Password is required",
  passwordMin: `MIn length is ${validation.passwordMin}`,
  passwordMax: `Max length is ${validation.passwordMax}`,
  phoneNumber: "Phone Number is required",
  phoneNumberMax: `Max Length is ${validation.phoneNumberMax}`,

  nameRequired: "Name is required",
  nameMin: `Max length is ${validation.nameMin}`,
  nameMax: `Max length is ${validation.nameMax}`,

  descriptionRequired: "Description is required",
  descriptionMax: `Max length is ${validation.descriptionMax}`,

  numberAllowed: "Only numbers are allowed",
  numberAndDecimalAllowed: "Only numbers and decimal are allowed",
};
export const localStorageConstant = {
  tokenKey: "project_name_token",
  userKey: "project_name_user",
};

export const public_routes = [
  {
    id: 0,
    route: "/",
    page: "Login",
    heading: "Effortless access to streamline your office work flow",
    description: "",
    component: <Login />,
    bg_image: "/images/auth.png",
  },
  {
    id: 1,
    route: "/forgot-password",
    page: "Forgot Password",
    heading: "Secure login in manage your office efficiently.",
    description: "",
    component: <ForgotPassword />,
    hasBackButton: true,
    bg_image: "/images/auth.png",
  },
  {
    id: 2,
    route: "set-new-password",
    page: "Set New Password",
    heading: "Secure login in manage your office efficiently.",
    description: "",
    component: <SetNewPassword />,
    bg_image: "/images/auth.png",
  },
  {
    id: 3,
    route: "/otp-verification",
    page: "OTP Verification",
    heading: "Secure login in manage your office efficiently.",
    description: "",
    component: <OTPVerification />,
    bg_image: "/images/auth.png",
  },
];

export const private_route = [
  {
    eventKey: "dashboard",
    component: <DashBoard />,
    text: "Dashboard",
    route: "/dashboard",
    role: [ROLE.ADMIN],
  },
  {
    eventKey: "staff",
    component: <StaffManagement />,
    text: "Staff",
    route: WEB_ROUTES.staff,
    role: [ROLE.ADMIN, ROLE.CLIENT],
  },
  {
    eventKey: "patients",
    component: <PatientsManagement />,
    text: "Patients",
    route: WEB_ROUTES.patient,
    role: [ROLE.ADMIN, ROLE.CLIENT],
  },
  {
    eventKey: "task",
    component: <TaskManagement />,
    text: "Task",
    route: WEB_ROUTES.task,
    role: [ROLE.CLIENT, ROLE.STAFF],
  },
  {
    eventKey: "appointment",
    component: <AppointmentManagement />,
    text: "Appointment",
    route: WEB_ROUTES.appointment,
    role: [ROLE.CLIENT],
  },
  {
    eventKey: "billing",
    component: <BillingManagement />,
    text: "Billing",
    route: WEB_ROUTES.billing,
    role: [ROLE.CLIENT],
  },
  {
    eventKey: "staffattendance",
    component: <StaffAttendanceManagement />,
    text: "Staff Attendance",
    route: WEB_ROUTES.staffattendance,
    role: [ROLE.CLIENT, ROLE.STAFF],
  },
  {
    eventKey: "settings",
    component: <Settings />,
    text: "Settings",
    route: WEB_ROUTES.settings,
    role: [ROLE.ADMIN, ROLE.CLIENT, ROLE.STAFF],
  },
];
export const NotiFicationData = [
  {
    message: (
      <div className="data">
        <div className="data-info">
          <div className="tittle">Subscription Renewal</div>
          <div className="mesg">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
      </div>
    ),
  },
  {
    message: (
      <div className="data">
        <div className="data-info">
          <div className="tittle">New Artist Album Update</div>
          <div className="mesg">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
      </div>
    ),
  },
  {
    message: (
      <div className="data">
        <div className="data-info">
          <div className="tittle">Announcements</div>
          <div className="mesg">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
      </div>
    ),
  },
  {
    message: (
      <div className="data">
        <div className="data-info">
          <div className="tittle">Upcoming Events</div>
          <div className="mesg">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
      </div>
    ),
  },
  {
    message: (
      <div className="data">
        <div className="data-info">
          <div className="tittle">Subscription Renewal</div>
          <div className="mesg">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
      </div>
    ),
  },
  {
    message: (
      <div className="data">
        <div className="data-info">
          <div className="tittle">New Artist Album Update</div>
          <div className="mesg">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
      </div>
    ),
  },
  {
    message: (
      <div className="data">
        <div className="data-info">
          <div className="tittle">Announcements</div>
          <div className="mesg">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
      </div>
    ),
  },
  {
    message: (
      <div className="data">
        <div className="data-info">
          <div className="tittle">Upcoming Events</div>
          <div className="mesg">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
      </div>
    ),
  },
  {
    message: (
      <div className="data">
        <div className="data-info">
          <div className="tittle">Subscription Renewal</div>
          <div className="mesg">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
      </div>
    ),
  },
  {
    message: (
      <div className="data">
        <div className="data-info">
          <div className="tittle">New Artist Album Update</div>
          <div className="mesg">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
      </div>
    ),
  },
  {
    message: (
      <div className="data">
        <div className="data-info">
          <div className="tittle">Announcements</div>
          <div className="mesg">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
      </div>
    ),
  },
  {
    message: (
      <div className="data">
        <div className="data-info">
          <div className="tittle">Upcoming Events</div>
          <div className="mesg">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
        </div>
      </div>
    ),
  },
];

export const API_ROUTE = {
  // MARK: AUTH
  login: "/api/user/login",
  forgotPassword: "/api/user/forgot-password",
  forgot_Otp: "/api/user/verify-otp/forgot-password",
  setNewPassword: "/api/user/set-password",
  getUserProfile: "/api/user/get-profile",
  updateUserProfile: "/api/user/update-profile",
  uploadAttachment: "/api/user/upload-attachments",

  // MARK: ADMIN
  getClients: "/api/admin/get-client",
  addClient: "/api/admin/add-client",
  updateClient: "/api/admin/update-client",
  deleteClient: "/api/admin/delete-client",

  // MARK: CLIENT
  getStaffs: "/api",
  addStaff: "/api/client/add-Staff",
  updateStaff: "/api/client/update-Staff",
  deleteStaff: "/api/client/delete-Staff",

  // MARK: PATIENT
  getPatients: "/api",
  addPatient: "/api/client/add-patient",
  updatPatient: "/api/client/update-patient",
  deletePatient: "/api/client/delete-patient",
  export_CSV: "/api",

  // MARK: TASK
  getTasks: "/api",
  addTask: "/api/client/tasks",
  updateTask: "/api/client/tasks",
  deleteTask: "/api/client/tasks",

  // MARK: APPOINTMENT
  getAppointments: "/api/client/appointments",
  addAppointment: "/api/client/appointments",
  updateAppointment: "/api/client/appointments",
  deleteAppointment: "/api/client/appointments",
  getAppointmentsByCalender: "/api/client/appointments/calendar",

  // MARK: BILLING
  getBillings: "/api/client/bills",
  addBilling: "/api/client/bills",
  updateBilling: "/api/client/bills",
  deleteBilling: "/api/client/bills",
  export_Billings: "/api/client/bills/export",

  // MARK: STAFF ATTENDANCE
  getStaffAttendances: "attendance-logs",
  completionSatus: "/api/staff/tasks/complete",
  addCheckOut: "api/staff/attendance-logs/checkout",
  addCheckIn: "api/staff/attendance-logs/checkin",

  // MARK: SETTINGS
  getSettings: "/api/setting/get-setting",
  updateSettings: "/api/setting/update-setting",
};
